import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Team icon
 *
 * @category Business
 */
const Team = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M8.936 9.13c-4.076-.15-4.474-6.127-.41-6.761 4.723-.522 5.332 6.45.596 6.76zm.025-5.556c-2.3.05-2.884 3.43-.646 4.189 3.156.969 4.064-3.928.807-4.189zm5.853 12.329c-.21.161-.596-.025-.77-.273-.124-.2-.187-.448-.261-.672-.634-2-2.647-3.492-4.748-3.492-2.1 0-4.126 1.467-4.76 3.468-.074.236-.136.497-.298.696s-.435.335-.659.223c-.298-.136-.323-.534-.286-.857.174-1.305.883-2.523 1.89-3.356 2.212-1.827 5.804-1.852 8.078-.112a5.2 5.2 0 0 1 1.566 1.976c.199.448.758 2.001.236 2.399zm8.129-6.773c-4.077-.15-4.475-6.127-.41-6.761 4.722-.522 5.331 6.45.596 6.76zm.012-5.556c-2.3.05-2.883 3.43-.646 4.189 3.156.969 4.064-3.928.808-4.189zm5.816 12.292c-.161.186-.41.186-.683-.2-.15-.21-.211-.471-.286-.72-.634-2.013-2.672-3.492-4.772-3.492s-4.127 1.503-4.748 3.517c-.062.211-.112.422-.236.597-.124.174-.323.323-.535.31-.223-.025-.41-.223-.472-.447s-.025-.46.025-.684a5.77 5.77 0 0 1 1.951-3.194c2.188-1.79 5.78-1.765 8.017-.05a5.05 5.05 0 0 1 1.652 2.225c.174.46.274 1.02.274 1.504 0 .236-.062.472-.174.609z"
        />
        <path
          fill="currentColor"
          d="M8.936 22.838c-4.71-.261-4.139-7.333.596-6.76 4.052.633 3.692 6.598-.41 6.76zm.025-5.568c-3.082.211-2.51 4.86.571 4.263 2.436-.56 2.026-4.188-.422-4.263zm5.829 12.329c-.212.137-.522.025-.684-.174s-.224-.46-.298-.709c-.61-2.025-2.635-3.53-4.748-3.542s-4.15 1.48-4.785 3.493c-.062.211-.111.422-.236.596s-.323.323-.534.311c-.236-.025-.41-.224-.472-.447-.063-.224-.025-.46.024-.684a5.8 5.8 0 0 1 1.976-3.182c2.15-1.752 5.58-1.764 7.818-.149 1.23.883 2.088 2.312 2.162 3.816 0 .236-.012.51-.223.658zm8.153-6.761c-4.71-.261-4.14-7.333.596-6.76 4.052.633 3.691 6.598-.41 6.76zm.012-5.568c-2.933.174-2.622 4.574.323 4.3 2.635-.348 2.424-4.176-.174-4.3zm5.779 12.242c-.174.15-.422.137-.671-.162-.373-.435-.385-1.08-.659-1.566-2-3.99-8.003-3.218-9.184 1.032-.224.97-1.268 1.143-1.193-.05.199-3.12 3.517-4.946 6.326-4.81 1.516.075 3.057.66 4.15 1.728.548.534.97 1.18 1.206 1.901.137.41.323.883.286 1.33-.012.261-.112.485-.26.597"
        />
      </svg>
    );
  }
);

Team.displayName = 'Team';

export { Team };
